import BaseController from '../../lib/BaseController';
import ajax from '../../services/Ajax';
import messages from '../../services/Messages';
import notification from '../../services/Notification';
import DateTimeFormatter from '../../lib/DateTimeFormatter';
import Validator from '../../lib/Validator';
import store from 'store';
import SAPService from '../services/SAPService';
import Utils from '../utility/Utils';

class RecordInspectionTimeController extends BaseController {
  constructor(jobId, testName, assets) {
    super('inspection-time', {
      jobId: jobId,
      testName: testName,
      assets: assets,
      inspectionMinutes: 0,
      inspectionDate: DateTimeFormatter.formatDate(DateTimeFormatter.today()),
      technician: '',
      errors: {},
      notesId: Utils.emptyGuid,
      notes: ''
    });
    this.getInspectionNotes();
    this.saving=false;
    this._validator = new Validator();
    this._validator.add('inspectionDate', 'Inspection Date must be less than or equal to today', [{ isLessThanEqualsDate: { params: this.state.inspectionDate } }]);
  }

  validate = (inspectionMinutes) => {
    try {
      const MAX_VALUE = (60 * 12); // 12 hrs per day is plenty
      const value = parseFloat(inspectionMinutes);

      if (isNaN(value)) {
        notification.action('warning').post({ msg: 'That is not a number – please re-enter.', title: 'No Value Warning' });
        return false;
      }
      else if (value > MAX_VALUE) {
        notification.action('warning').post({ msg: 'Did you really work over 12 hours on this task? That value is too high to be accepted – please re-enter.', title: 'Limit Warning' });
        return false;
      }
      else if (value < 0) {
        notification.action('warning').post({ msg: 'The number must be greater than 0 (zero) – please re-enter.', title: 'Negative Value Warning' });
        return false;
      }
      else if (value === 0) {
        notification.action('warning').post({ msg: 'That is not a valid value – it evaluates to 0 (zero) – please re-enter.', title: 'Zero Value Warning' });
        return false;
      }
      return true;
    }
    catch (err) {
      notification.action('error').post({ msg: 'The value for Inspection Minutes is not valid – please re-enter', title: 'Conversion Error' });
      return false;
    }
  }
  getInspectionNotes = () => {
    const s = this.state;
    const param = {
      jobId: s.jobId,
      testName: s.testName,
      assetId: s.assets[0].jobSOWId,
    }
    ajax.post('lookup/getInspectionTestNotes', param).then(result => {
      if (result) {
        this.state.notesId = result.notesId || Utils.emptyGuid
        this.state.notes = result.notes || '';
        this.commit();
      }
    }).catch(err => {
      notification.action('error').post({ msg: err.message, title: 'Error' });
    });
  }

  addTime = (value) => {
    this.state.inspectionMinutes += value;
    if (this.state.inspectionMinutes < 0) {
      this.state.inspectionMinutes = 0;
    }
    this.commit();
  }

  canSave = () => {
    const self = this;
    this._validator.validateAll(self.state);

    const errors = Object.keys(self.state.errors);
    if (!errors.length) {
      return true;
    }

    self.commit();
    return false;
  }

  save() {
    if (!this.canSave()) {
      return;
    }
    this.saving=true;
    const inspectionMinutes = this.state.inspectionMinutes;
    if (!this.validate(inspectionMinutes)) {
      return false;
    }
    const loginInfo = store.get('InteServLoginInfo');
    if (SAPService.isSAPFacility() && SAPService.isTTSEnabled()) {
      if (!loginInfo.isClockedIn) {
        notification.action('error').post("Currently Not Clocked In");
        this.saving=false;
        return false;
      }
      if (loginInfo.isClockedOut) {
        notification.action('error').post("ClockedOut for the day");
        this.saving=false;
        return false;
      }
      if (loginInfo.isBreakOut) {
        notification.action('error').post("Currently on Unpaid break");
        this.saving=false;
        return false;
      }
      if (parseFloat(inspectionMinutes).toFixed(1) <= 0) {
        notification.action('error').post("After rounding to 1 decimal, time will become 0. Inspection Time should be greater than 0");
        this.saving=false;
        return false;
      }
      var availableTime = (DateTimeFormatter.getDuration(loginInfo.clockedInTime, loginInfo.isBreakOut ? loginInfo.breakOutTime : DateTimeFormatter.formatLocalTime(DateTimeFormatter.now())) - (loginInfo.totalBreakTime + (loginInfo.totalProductiveTime || 0)));

      if (inspectionMinutes > availableTime) {
        notification.action('error').post("Time should not be more than Available Production Time");
        this.saving=false;
        return false;
      }
    }
    var s = this.state;
    var parameters = {
      jobId: s.jobId,
      testName: s.testName,
      assets: s.assets.map(asset => asset.jobSOWId),
      inspectionMinutes: parseFloat(inspectionMinutes),
      inspectionDate: s.inspectionDate,
      technician: s.technician,
      today: DateTimeFormatter.formatDate(DateTimeFormatter.today()),
      notesId: s.notesId,
      notes: s.notes || null
    };

    return ajax.post('inspection/recordInspectionTime', parameters).then(prodTime => {
      this.saving=false;
      this.commit();
      messages.channel('productiveTime').action('update').post(prodTime);
      messages.channel('reload-test-results').action('saved').post();
      return true;
    }).catch(err => {
      this.saving=false;
      this.commit();
      notification.action('error').post({ msg: err.message, title: 'Error' });
      return false;
    });
  }
}

export default RecordInspectionTimeController;
